module.exports = __webpack_public_path__ + "img/lamp.a2c929f.svg";